import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckCircleFilled } from '../../assets/images/icons/check_circle_filled_yellow.svg';
import styles from './OutcomesChecklist.module.scss';

export default function OutcomesChecklist() {
  const { t } = useTranslation();

  const outcomes = [
    t('referral_v2_track_live_location'),
    t('referral_v2_escape_alerts'),
    t('referral_v2_health_tracking'),
    t('referral_v2_daily_activity_goals'),
  ];

  return (
    <div className={styles.container}>
      {outcomes.map((outcome) => (
        <div key={outcome} className={styles.item}>
          <CheckCircleFilled className={styles.icon} />
          <span>{outcome}</span>
        </div>
      ))}
    </div>
  );
}
